
module.exports = {
  // TODO: change your profile information here
  name: "Anutosh Ghosh",
  greeting: "Hey 👋",
  greetingDescription: "I'm Anutosh Ghosh and I'm a Web Developer!",
  githubUrl: "https://github.com/anutosh38",
  linkedinUrl: "https://www.linkedin.com/in/anutosh-ghosh-3789aa8a/",
  cvLink: "https://docs.google.com/document/d/1E1234561NMyQA67890ygda7abcdefghijs1jBp7HFI0/",
};
